import { Logger } from "tslog";
export const logger = new Logger({
    name: "Excel Core",
});
//# sourceMappingURL=tslog.js.map